import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

export default function ConfirmModal({ title, message, confirmLabel = 'Confirm', cancelLabel = 'Cancel', onConfirm, onCancel }) {
  useEffect(() => {
    // Close on Escape
    const handler = (e) => { if (e.key === 'Escape') onCancel(); };
    document.addEventListener('keydown', handler);

    // Lock body scroll while modal is open
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handler);
      document.body.style.overflow = prev;
    };
  }, [onCancel]);

  return createPortal(
    <div className="sh-modal-overlay" onClick={onCancel}>
      <div
        className="sh-modal"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="sh-modal-title">{title}</h3>
        <p className="sh-modal-message">{message}</p>
        <div className="sh-modal-actions">
          <button className="sh-modal-btn sh-modal-btn--cancel" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button className="sh-modal-btn sh-modal-btn--confirm" onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
